import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'
import { getSubgraphUrl } from 'config/subgraph'

export function createClient(chainId: number, subgraph: string) {
  const url = getSubgraphUrl(chainId, subgraph)
  const httpLink = new HttpLink({
    uri: url,
    credentials: 'include',
    fetchOptions: {
      mode: 'cors',
    },
    headers: {
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_SUBGRAPH_API_KEY}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
    },
  })

  const link = url?.includes('/subgraph/') ? { link: httpLink } : { uri: url }

  return new ApolloClient({
    ...link,
    cache: new InMemoryCache(),
  })
}
